"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var CustomPropTypes = _interopRequireWildcard(require("../../../constants/PropTypes"));

var _reactRedux = require("react-redux");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = require("HubStyleTokens/colors");

var _times = require("HubStyleTokens/times");

var _UIRouterLink = _interopRequireDefault(require("ui-addon-react-router-dom/UIRouterLink"));

var _AppCard = _interopRequireDefault(require("ecosystem-marketplace-core/components/cards/AppCard"));

var _auth = require("../../../selectors/auth");

var _urls = require("../../../utils/urls");

var _PieSyncConnectorIcon = _interopRequireDefault(require("../../common/PieSyncConnectorIcon"));

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  && {\n    border: 2px solid transparent;\n    transition: border ", " ease-out;\n\n    &:hover {\n      border-color: ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: flex;\n  align-items: stretch;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledRouterLink = (0, _styledComponents.default)(_UIRouterLink.default).withConfig({
  displayName: "ResultCard__StyledRouterLink",
  componentId: "sc-1oiob8j-0"
})(_templateObject());
var StyledAppCard = (0, _styledComponents.default)(_AppCard.default).withConfig({
  displayName: "ResultCard__StyledAppCard",
  componentId: "sc-1oiob8j-1"
})(_templateObject2(), _times.MICRO_TRANSITION_TIMING, _colors.CALYPSO_MEDIUM);

var ResultCard = function ResultCard(_ref) {
  var collection = _ref.collection,
      onClick = _ref.onClick,
      result = _ref.result,
      showCommitmentPrice = _ref.showCommitmentPrice;
  var category = result.category,
      companyName = result.companyName,
      firstPublishedAt = result.firstPublishedAt,
      hubInstalls = result.hubInstalls,
      iconUrl = result.iconUrl,
      installed = result.installed,
      minCents = result.minCents,
      minCommitmentCents = result.minCommitmentCents,
      minPlanType = result.minPlanType,
      name = result.name,
      nativeId = result.nativeId,
      offeringId = result.offeringId,
      pricingsCount = result.pricingsCount,
      reviewSummary = result.reviewSummary,
      slug = result.slug,
      tagline = result.tagline;
  var isUngatedForRemovePieSyncConnectorInstallCount = (0, _reactRedux.useSelector)(_auth.getIsUngatedForRemovePieSyncConnectorInstallCount);
  return _react.default.createElement(StyledRouterLink, {
    onClick: onClick,
    to: (0, _urls.getListingDetailUrl)(slug, category),
    use: "unstyled"
  }, _react.default.createElement(StyledAppCard, {
    activeCollection: collection,
    category: category,
    companyName: companyName,
    className: "m-bottom-0",
    firstPublishedAt: firstPublishedAt,
    hubInstalls: hubInstalls,
    iconUrl: iconUrl,
    installed: installed,
    isUngatedForRemovePieSyncConnectorInstallCount: isUngatedForRemovePieSyncConnectorInstallCount,
    minCents: minCents,
    minCommitmentCents: minCommitmentCents,
    minPlanType: minPlanType,
    name: name,
    nativeId: nativeId,
    offeringId: offeringId,
    pieSyncConnectorIconComponent: _PieSyncConnectorIcon.default,
    pricingsCount: pricingsCount,
    reviewSummary: reviewSummary,
    showCommitmentPrice: showCommitmentPrice,
    slug: slug,
    tagline: tagline
  }));
};

ResultCard.propTypes = {
  collection: _propTypes.default.string,
  onClick: _propTypes.default.func,
  result: _reactImmutableProptypes.default.recordOf({
    category: CustomPropTypes.category.isRequired,
    firstPublishedAt: _propTypes.default.number.isRequired,
    hubInstalls: _propTypes.default.number.isRequired,
    iconUrl: _propTypes.default.string.isRequired,
    installed: _propTypes.default.bool.isRequired,
    minCents: _propTypes.default.number,
    minCommitmentCents: _propTypes.default.number,
    minPlanType: CustomPropTypes.pricingPlanType,
    name: _propTypes.default.string.isRequired,
    nativeId: _propTypes.default.string.isRequired,
    offeringId: _propTypes.default.number.isRequired,
    pricingsCount: _propTypes.default.number.isRequired,
    slug: _propTypes.default.string.isRequired,
    tagline: _propTypes.default.string.isRequired
  }),
  showCommitmentPrice: _propTypes.default.bool
};
ResultCard.defaultProps = {
  showCommitmentPrice: true
};
var _default = ResultCard;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/storefront/results/ResultCard.js
// module id = 881
// module chunks = 209 210 211 212